<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { visitors, loggedinUsers } from './plugins/intercome';

export default {
  name: 'App',
  updated() {
    if (this.$store.state.isLoggedIn) {
      const fisrtName =
        this.$store.state.employeeData?.user_info?.first_name ?? '';
      const lastName =
        this.$store.state.employeeData?.user_info?.last_name ?? '';

      loggedinUsers({
        userName: `${fisrtName} ${lastName}`,
        userEmail: this.$store.state.employeeData?.user_info?.email ?? '',
        userId: this.$store.state.employeeData?.user_info?.id ?? null
      });
      window.Intercom('update');
    } else {
      window.Intercom('shutdown');
      visitors();
      window.Intercom('update');
    }
  }
};
</script>

<style lang="scss">
$skroutzOrange: #f68b24 !default;
$primary: $skroutzOrange;

@import '~bootstrap/scss/bootstrap.scss';
@import '../node_modules/bootstrap-vue/src/index.scss';
@import './assets/styles/fonts.scss';

$proxima-nova: 'Proxima Nova', sans-serif;

body {
  font-family: $proxima-nova !important;
}

input,
select,
textarea,
button {
  margin: 0; // Overwrite Safari default margins
  outline: none;
  font-family: inherit;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}
</style>
